import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import ItemService from "../../../../services/customer_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
// import PageLevelRiverseTimer from "../../../../Components/PageLevelRiverseTimer";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import toast from "react-hot-toast";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/CustomerConstants";
import {
  formatDateTime,
  formatPriceValue,
  isValidNumber,
  // getCurrentDate,
} from "../../../../common/Validations";
// import { getQuotation } from "../../../../redux/feature/supplier_app/sourcingSlice";

const CreateQuotation = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Pre Sales");
  localStorage.setItem("submenu", "Inquiry");

  let completedInquiryList = useSelector(
    (state) => state?.preSales?.inquiry?.completedInquiryList,
  ); /* completedInquiryList from store*/

  let userData = useSelector((state) => state?.user); // User Details from Store

  let dropdownOption = [
    {
      id: "1",
      name: "Sample Data 1",
    },
    {
      id: "2",
      name: "Sample Data 2",
    },
  ];

  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);

  const [subTotalValue, setSubTotalValue] = useState(0);
  const [itemTableData, setItemTableData] = useState([]);

  const [getDropdownData, setDropdownData] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const modalData = {
    title: "Quotation Creation",
    successMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);

  const [formInputs, setFormInputs] = useState({
    transactionType: "INQTN",
    module: "CUSTOMER",
    rfxNr: "",
    quotationSubmittedBy: "",
    salesOfficerCode: "30060",
    salesOfficerName: "T Sreekanth Reddy",
    qtnSubmittedID: "",
    vendorCode: "",
    productType: "",
    rfxHeaderStatus: "",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    qtnPaymentTerms: "",
    qtnBidderCurrency: "",
    technicalQuoteArticle: "",
    qtnPricingNotes: "",
    unpricedCommercia: "",
    lQuoteArticle: "",
    quotationNotes: "",
    commercialQuoteArticle: "",
    quotationStatus: "",
    buyerResponsible: "",
    companyAddress: "",
    buyerEmail: "",
    initiatorName: "",
    initiator: "",
    createdOn: "",
    buyerConact: "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: "",
    rfxCateDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    rfxTypeDesc: "",
    productTypeDesc: "",
    rfxbidTypeDesc: "",
    rfxNoOfEvaluationTypeDesc: "",
    rfxCurrencyCode: "",
    rfxCurrencyDesc: "",
    technicalApprovalTypeDesc: "",
    companyAddressDesc: "",
    plantDesc: "",
    billingAddressDesc: "",
    unpricedCommercialQuoteArticle: "",
    pricingNotes: "",
    qtnIncoTerms: "",
    qtnVersion: "V1",
    quotationReference: "",
    acceptanceTermsConditions: "",

    items: [
      {
        qtnItem: 1,
        nstatusItem: "",
        qtnQuantity: 10,
        qtnQuantityUnit: "",
        purchaseDocumentNr: "",
        purchaseDocumentItem: "",
        quotationNr: "",
      },
    ],
    formCOMM: [],
    formTECH: [],
  });

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [selectedShipment, setSelectedShipment] = useState("Yes");
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);

  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // OnClick on lineItem  Data
  // eslint-disable-next-line no-unused-vars
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // Function to handle text changes
  const handleInputChangeTable = (id, value, qtnQuantity) => {
    let totalPriceVal = Number(qtnQuantity) * Number(value);

    const updatedData = itemTableData.map((item) => {
      return item.local_id === id
        ? {
            ...item,
            quotationUnitPrice: value,
            qtnitemValue: totalPriceVal,
            qtnQuantity: qtnQuantity,
          }
        : item;
    });

    setItemTableData(updatedData);
    getTotalCount(updatedData);
  };

  // Function to handle text changes
  const handleDeliveryLeadTime = (id, value) => {
    const updatedData = itemTableData.map((item) => {
      return item.local_id === id
        ? {
            ...item,
            deliveryLeadTime: value,
          }
        : item;
    });
    setItemTableData(updatedData);
  };

  const handleQtnQuantityTable = (id, value, qtnQuantity) => {
    if (Number(qtnQuantity) >= Number(value)) {
      const updatedData = itemTableData.map((item) => {
        return item.local_id === id
          ? {
              ...item,
              qtnQuantity: value,
            }
          : item;
      });

      setItemTableData(updatedData);
    } else {
      // console.log("Do Nothing");
    }
  };

  // Get Total for SubTotal Pricing Schedule
  const getTotalCount = (data) => {
    const getTotal = data.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.qtnitemValue || 0),
      0,
    );
    setSubTotalValue(getTotal);
  };

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setItemTableData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.inquiryQuantity || 0) *
                          Number(row.quotationUnitPrice || 0))
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setItemTableData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Get Total for SubTotal Pricing Schedule
  useEffect(() => {
    // console.log(">> itemTableData", itemTableData);

    const getItemTotal = itemTableData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.qtnitemValue || 0),
      0,
    );
    const taxTotalAmount = itemTableData?.reduce(
      (accumulator, currentValue) =>
        accumulator + (currentValue?.taxAmount || 0),
      0,
    );

    setTaxAmountValue(taxTotalAmount);
    setItemAmountValue(getItemTotal);

    setSubTotalValue(getItemTotal + taxTotalAmount);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemTableData]);

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Sl no",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "80px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Inquiry Qty ",
      selector: (row) => row.inquiryQuantity || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Qtn Quantity ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="qtnQuantity"
            name="qtnQuantity"
            value={row.inquiryQuantity || 0}
            onChange={(e) =>
              handleQtnQuantityTable(
                row.local_id,
                e.target.value,
                row.inquiryQuantity,
              )
            }
            disabled={true}
          />
        </>
      ),
      width: "160px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      width: "100px",
    },
    {
      name: "Unit Price ",
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="quotationUnitPrice"
            name="quotationUnitPrice"
            value={row.quotationUnitPrice || 0}
            onChange={(e) =>
              handleInputChangeTable(
                row.local_id,
                e.target.value,
                row.inquiryQuantity,
              )
            }
          />
        </>
      ),
      width: "180px",
    },
    {
      name: "Item Value ", // calculation
      selector: (row) => formatPriceValue(row.qtnitemValue),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Lead Time (Days)", // input
      cell: (row) => (
        <>
          <InputField
            type="number"
            className="inputBox mt-1"
            id="deliveryLeadTime2"
            name="deliveryLeadTime"
            value={row.deliveryLeadTime || 0}
            onChange={(e) =>
              handleDeliveryLeadTime(row.local_id, e.target.value)
            }
          />
        </>
      ),
      width: "200px",
    },
    {
      name: "Deviation", // input yes/NO
      selector: (row) => row.deviation || "--",
      cell: (row) => (
        <>
          <ComboboxField
            placeholder=""
            data={dropdownOption}
            id="deviation"
            name="deviation"
            value={row.deviation || 0}
          />
        </>
      ),
      width: "200px",
    },
    {
      name: "Deviation Remarks", // input
      selector: (row) => row.deviationRemark || "--",
      cell: (row) => (
        <>
          <TextAreaField
            className="inputBox mt-1"
            id="deviation"
            name="deviation"
            value={row.deviation}
          />
        </>
      ),
      width: "200px",
    },
  ];

  // Other Charges
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Other Charges selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0,
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);

  /* Create Other Charges Modal Function */
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  const loadInitialPageData = async () => {
    // setLoading(true);
    if (completedInquiryList) {
      const updatedProducts = completedInquiryList?.items.map(
        (item, index) => ({
          ...item,
          local_id: `${index + 1}`, // Adding local_id based on the index
        }),
      );

      setItemTableData(updatedProducts);
    } else {
      window.history.back();
    }
  };

  useEffect(() => {
    loadInitialPageData();
    getMasterDataFunc();
    setFormInputs(completedInquiryList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completedInquiryList]);

  //Load Master Data
  const getMasterDataFunc = async () => {
    // 1

    let obj4 = {
      codeType: "INCOTerms",
    };
    await ItemService.getMasterData(obj4).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj5 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj6).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  // SAVE
  const handleSave = async () => {
    // let requiredFields = [];

    // if(!validateRequired(formInputs?.organisationName)) {
    //   requiredFields.push('*Please enter Supplier Name');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateEmail(formInputs?.email)) {
    //   requiredFields.push('*Invalid Contact Email address');
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!getPOLineItemsData[0]?.materialCode) {
    //   toast.error("Alteast one PO Line item should be added.", {
    //     duration: 4000,
    //     position: "top-right",
    //   });
    //   return;
    // }
    // console.log(formInputs);
    formInputs.vendorCode = userData?.data?.userId;
    formInputs.qtnVersion = "V0";
    formInputs.quotationStatus = "Submitted";
    formInputs.quotationSubmittedBy = userData?.data?.firstName;
    formInputs.qtnSubmittedID = userData?.data?.userId;
    formInputs.othersCharge = getHeaderTextSelectedData;
    formInputs.qtnSubTotalLineItem = subTotalValue;
    formInputs.qtnSubTotalOtherCharges = getOtherChargesValue;
    formInputs.qtnTotal = subTotalValue + getOtherChargesValue;
    formInputs.acceptanceTermsConditions = selectedShipment;
    formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
    formInputs.transactionType = "INQTN";
formInputs.module = "CUSTOMER";

    const userEnteredItemTableData = itemTableData.filter(
      (item) => item.quotationUnitPrice != null || item.quotationUnitPrice > 0,
    );
    formInputs.items = userEnteredItemTableData;

    // console.log(">> handleSave", formInputs);

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    let obj = {
      data: formInputs,
    };
   

    setDisabled(true);
    await ItemService.addQuotation(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();

        // Update response value in Redux Store
        // dispatch(getQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };
  // Get Dropdown data select
  useEffect(() => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.code,
      [getDropdownData?.textDesc]: getDropdownData?.description,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // eslint-disable-next-line no-unused-vars
  const handleShipmentChange = (event) => {
    setSelectedShipment(event.target.value);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Quotation tst</h2>
            <p className="subText">Fill Quotatoin Details</p>
            <hr />

            {/* Quotation overview */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QO</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Quotation Overview</span>
                      <span className="subHeaderTitle">Quotation Overview</span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inquiry Nr"
                          name="inquiryNr"
                          id="inquiryNr"
                          value={formInputs?.inquiryNr}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inquiry Date"
                          name="inquiryDocumentType"
                          id="inquiryDocumentType"
                          value={formatDateTime(
                            formInputs?.inquiryDocumentType,
                          )}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Code"
                          name="customerCode"
                          placeholder=""
                          value={formInputs.customerCode || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer Name"
                          name="customerName"
                          placeholder=""
                          value={formInputs.customerName || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sold to Party"
                          type="text"
                          name="soldToParty"
                          placeholder=""
                          value={formInputs.customerCode || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Ship to Party"
                          name="shipToParty"
                          placeholder=""
                          value={formInputs.customerCode || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Payment Terms"
                          name="paymentTerms"
                          placeholder=""
                          value={formInputs.paymentTerms || ""}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inco Terms"
                          name="incoTerms"
                          placeholder=""
                          value={formInputs.incoTerms || ""}
                          disabled={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sales Organization"
                          name="salesOrg"
                          placeholder=""
                          value={formInputs.salesOrg || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Disrtibution Channel"
                          name="disrtibutionChannel"
                          placeholder=""
                          value={formInputs.disrtibutionChannel || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Division"
                          name="division"
                          placeholder=""
                          value={formInputs.division || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Remark"
                          type="text"
                          name="inquiryRemark"
                          id="inquiryRemark"
                          placeholder=""
                          value={formInputs?.inquiryRemark || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Quotation Header Info */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QI</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Quotation Header Info</span>
                      <span className="subHeaderTitle">
                        Quotation Header Information
                      </span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="icv29"
                          className="inputBox"
                          label="ICV Value"
                          name="ICV Value"
                          placeholder=""
                          value={formInputs.firstName || ""}
                          onChange={onInputChange}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="quotationReference"
                          className="inputBox"
                          label="Quotation Reference"
                          name="quotationReference"
                          placeholder=""
                          value={formInputs.quotationReference}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="quotationSubmissionDate"
                          className="inputBox"
                          type="date"
                          label="Quotation Date"
                          name="quotationSubmissionDate"
                          placeholder=""
                          value={formInputs.quotationSubmissionDate}
                          onChange={onInputChange}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="ICVValidity32"
                          className="inputBox"
                          label="ICV Validity"
                          name="description"
                          placeholder=""
                          value={formInputs.firstName || ""}
                          onChange={onInputChange}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Payment term"
                          placeholder=""
                          data={getpaymentTerm}
                          id="qtnPaymentTerms"
                          iconClassName="dropdownIcon"
                          name="qtnPaymentTerms"
                          code="qtnPaymentTermsCode"
                          description="qtnPaymentTermsDesc"
                          setValue={formInputs.qtnPaymentTerms}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Inco Terms"
                          placeholder=""
                          data={getINCOTerms}
                          id="qtnIncoTerms"
                          iconClassName="dropdownIcon"
                          name="qtnIncoTerms"
                          code="qtnIncoTermsCode"
                          description="qtnIncoTermsDesc"
                          setValue={formInputs.qtnIncoTerms}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Currency"
                          placeholder=""
                          data={getcurrency}
                          id="qtnBidderCurrency"
                          iconClassName="dropdownIcon"
                          name="qtnBidderCurrency"
                          code="qtnBidderCurrencyCode"
                          description="qtnBidderCurrencyDesc"
                          setValue={formInputs.qtnBidderCurrency}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col>

                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="ICV CERTIFICATE"
                          placeholder=""
                          data={dropdownOption}
                          id="paymentterm"
                          iconClassName="dropdownIcon"
                          name="paymentterm"
                          setValue={formInputs.paymentterm || ""}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Pricing Notes"
                          type="text"
                          name="qtnPricingNotes"
                          id="qtnPricingNotes"
                          placeholder=""
                          value={formInputs.qtnPricingNotes || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Quotation Notes"
                          type="text"
                          name="quotationNotes"
                          id="quotationNotes"
                          placeholder=""
                          value={formInputs.quotationNotes || ""}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="commercialQuoteArticle"
                          className="inputBox"
                          label="COMMERIAL PROPOSAL"
                          type="file"
                          name="commercialQuoteArticle"
                          placeholder=""
                          value={formInputs.commercialQuoteArticle}
                          onChange={onInputChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PI</span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <span className="headerTitle">
                        Price Shedule / Line Item
                      </span>
                      <span className="subHeaderTitle">
                        Price Shedule / Line Item
                      </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      {/* <Col xs={4} md={2} lg={2} className="">
                        <button className="btnTable">Download Template</button>
                      </Col>
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={() => {
                            alert("asd");
                          }}
                        >
                          Upload Date
                        </button>
                      </Col> */}
                      {/* <Col xs={1} md={1} lg={1} className="">
                        <SourcingCommonFilter />
                      </Col> */}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={PRLineItemInitialCol}
                          data={itemTableData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* other Charges table */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>

                    <Col xs={4} md={6} lg={6}>
                      <span className="headerTitle">Other Charges</span>
                      <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={4} lg={4} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={showsetHeaderText}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </Col>
                      {/* <Col xs={1} md={1} lg={1} className="">
                        <SourcingCommonFilter />
                      </Col> */}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={HeaderTextColumns}
                          data={getHeaderTextSelectedData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination

                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Pricing Summary */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible6
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>
                    <Col xs={12} md={4} lg={4}>
                      <span className="headerTitle">Pricing Summary</span>
                      <span className="subHeaderTitle">Pricing Summary </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible6 ? "visible" : ""
                  }`}
                >
                  <Row className="my-4 ms-3 ">
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <p className="fw-medium">
                        SubTotal Pricing Schedule / Line Items (A){" "}
                      </p>
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={6}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <InputField
                        id="subTotalValue36"
                        className="inputBox"
                        name="subTotalValue"
                        placeholder=""
                        value={subTotalValue}
                        disabled={getDisabledStatus}
                      />
                      <p className="ms-4 fw-medium">
                        {" "}
                        {formInputs?.rfxCurrency}
                      </p>
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="d-flex mb-2 jsutify-content-center align-items-center "
                    >
                      <p className="fw-medium"> SubTotal Other Charges (B)</p>
                    </Col>
                    <Col
                      xs={12}
                      md={7}
                      lg={7}
                      className="d-flex mb-2 jsutify-content-center align-items-center "
                    >
                      <InputField
                        id="getOtherChargesValue37"
                        className="inputBox"
                        name="getOtherChargesValue"
                        placeholder=""
                        value={getOtherChargesValue}
                        disabled={getDisabledStatus}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <p className="fw-medium">
                        Quotation Gross Total (C = A + B)
                      </p>
                    </Col>
                    <Col
                      xs={12}
                      md={7}
                      lg={7}
                      className="d-flex mb-2 jsutify-content-center align-items-center"
                    >
                      <InputField
                        id="Closing38"
                        className="inputBox"
                        /* label="Closing Date:" */
                        name="firstName"
                        placeholder=""
                        value={subTotalValue + getOtherChargesValue}
                        onChange={onInputChange}
                        disabled={getDisabledStatus}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <div className="pageFooter">
        <Row className="rowDirection">
          <>
            <Col
              xs={12}
              md={2}
              lg={2}
              className="commTopButtonRightLeftPadding"
            >
              <button
                className="btn btnTable w-full"
                onClick={handleSave}
                disabled={disabled}
              >
                <i className="bi bi-save"></i> Create
              </button>
            </Col>
            {/* <Col
              xs={12}
              md={2}
              lg={2}
              className="commTopButtonRightLeftPadding"
            >
              <button
                className="btn btnTable w-full"
                onClick={handleSave}
                disabled={disabled}
              >
                <i className="bi bi-save"></i> Modify
              </button>
            </Col> */}
            {/* <Col xs={12} md={2} lg={2} className="commTopButtonRightLeftPadding">
            <button
              className="btn btnTable w-full"
              //  onClick={handleModify}
            >
              <i className="bi bi-pencil-square"></i> Modify
            </button>
          </Col> */}
          </>
        </Row>
      </div>

      {/* <CreateOtherChanges
        show={otherchangesmodelshow}
        onHide={hideOtherChangesModel}
        onData={handleDataFromCreateOtherChanges}
      /> */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.PRESALES_CUSTOMER_QUOTATION_LIST}
      />
    </main>
  );
};

export default CreateQuotation;
